'use client';

import React from 'react';
import dynamic from 'next/dynamic';

import { Container } from '@/components/Container';
import { FullArticle } from '@/components/FullArticle/FullArticle';
import { AdditionalPaddings } from '@/components/Layouts/AdditionalPadding';
import { BlogLayout } from '@/components/Layouts/BlogLayout';
import { FeaturesLayout } from '@/components/Layouts/FeaturesLayout';
import Section from '@/components/Section/Section';
import { ArticlesList } from '@/features/ArticlesList/ArticlesList';
import { Banner } from '@/features/Banner/Banner';
import { BookDemo } from '@/features/BookDemo/BookDemo';
import { ExploreTools } from '@/features/ExploreTools/ExploreTools';
import { FAQ } from '@/features/FAQ/FAQ';
import { FeaturesIntro } from '@/features/FeaturesIntro/FeaturesIntro';
import { Testimonals } from '@/features/Testimonals/Testimonals';
import { WorkFlowV2 } from '@/features/WorkFlow/WorkFlowV2';
import {
  articles,
  blog,
  bookDemo,
  explore,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
} from '@/lib/features/estimating';

const BlogDynamic = dynamic(() => import('@/features/Blog/Blog'), {
  ssr: false,
});

const EstimatingPage = () => {
  return (
    <>
      <FeaturesIntro {...intro} />

      <WorkFlowV2 />

      <Section>
        <Container>
          <FullArticle revert={true} item={fullArticle2} />
        </Container>
      </Section>

      <Container>
        <Section title={articles.title}>
          <ArticlesList {...articles} />
        </Section>
      </Container>

      <Section>
        <AdditionalPaddings>
          <Banner
            title={`Orcatec streamlines your estimation process, enabling you to deliver `}
            secondaryTitle=" accurate and professional proposals faster than ever"
            subTitle="Ready to Transform Your Estimation Process?"
            listItems={[]}
          />
        </AdditionalPaddings>
      </Section>

      <Section>
        <Container>
          <FullArticle revert={false} item={fullArticle1} />
        </Container>
      </Section>

      <Section>
        <Container>
          <ExploreTools {...explore} />
        </Container>
      </Section>

      <FeaturesLayout>
        <Section>
          <Banner
            title={`Contact us and try a cutting-edge estimate tool for free  `}
            subTitle="Explore Orcatec’s Tools Now!"
            secondaryTitle="No obligations. No credit card required."
            listItems={[]}
          />
        </Section>

        <Section>
          <Container>
            <Testimonals {...testimonals} />
          </Container>
        </Section>

        <Container>
          <Section title={faq.title}>
            <FAQ {...faq} />
          </Section>
        </Container>
      </FeaturesLayout>

      <BlogLayout>
        <Container>
          <Section title={blog.title} description={blog.description}>
            <BlogDynamic />
          </Section>
        </Container>
      </BlogLayout>

      <BookDemo {...bookDemo} />
    </>
  );
};

export default EstimatingPage;
